var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 14,
    viewBox: "0 0 8 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 13L3.64645 13.3536L4 13.7071L4.35355 13.3536L4 13ZM4.5 1C4.5 0.723858 4.27614 0.5 4 0.5C3.72386 0.5 3.5 0.723858 3.5 1L4.5 1ZM7.35355 10.3536C7.54882 10.1583 7.54882 9.84171 7.35355 9.64645C7.15829 9.45118 6.84171 9.45118 6.64645 9.64645L7.35355 10.3536ZM1.35355 9.64645C1.15829 9.45118 0.841709 9.45118 0.646446 9.64645C0.451184 9.84171 0.451184 10.1583 0.646446 10.3536L1.35355 9.64645ZM4.5 13L4.5 1L3.5 1L3.5 13L4.5 13ZM4.35355 13.3536L6.35355 11.3536L5.64645 10.6464L3.64645 12.6464L4.35355 13.3536ZM6.35355 11.3536L7.35355 10.3536L6.64645 9.64645L5.64645 10.6464L6.35355 11.3536ZM1.64645 11.3536L3.64645 13.3536L4.35355 12.6464L2.35355 10.6464L1.64645 11.3536ZM0.646446 10.3536L1.64645 11.3536L2.35355 10.6464L1.35355 9.64645L0.646446 10.3536Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDown);
export default __webpack_public_path__ + "static/media/arrow-down.c8ac78fa2b428a399b801653792e29b0.svg";
export { ForwardRef as ReactComponent };